(function () {
  const SELECTORS = {
    root: "[data-codex-sticky-atc]",
    footer:
      ".shopify-section-group-footer-group .footer__bottom, .shopify-section-group-footer-group .footer__top, footer.footer",
    variantSelect: "[data-codex-variant]",
  };

  const initSection = (root) => {
    if (!root || root.dataset.codexStickyAtcInit === "true") return;
    root.dataset.codexStickyAtcInit = "true";

    const stickyVariantInput = root.querySelector('input[name="id"]');
    const stickySubmit = root.querySelector("[data-codex-sticky-atc-submit]");
    const stickyPrice = root.querySelector("[data-codex-sticky-atc-price]");
    const stickyCompare = root.querySelector("[data-codex-sticky-atc-compare]");
    const variantSelect = document.querySelector(SELECTORS.variantSelect);
    const availableLabel =
      stickySubmit?.dataset.availableLabel ||
      stickySubmit?.textContent.trim() ||
      "Add to cart";
    const soldOutLabel = stickySubmit?.dataset.soldOutLabel || "Sold Out";

    const syncVariantFromHero = () => {
      if (!variantSelect || !stickyVariantInput) return;

      const option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      stickyVariantInput.value = option.value;

      const available = option.getAttribute("data-available") === "true";
      stickyVariantInput.disabled = !available;

      if (stickySubmit) {
        stickySubmit.disabled = !available;
        stickySubmit.setAttribute("aria-disabled", available ? "false" : "true");
        stickySubmit.textContent = available ? availableLabel : soldOutLabel;
      }

      const price = option.getAttribute("data-price");
      if (stickyPrice && price) stickyPrice.textContent = price;

      if (stickyCompare) {
        const compare = option.getAttribute("data-compare") || "";
        if (compare) {
          stickyCompare.textContent = compare;
          stickyCompare.hidden = false;
        } else {
          stickyCompare.hidden = true;
        }
      }
    };

    if (variantSelect) {
      variantSelect.addEventListener("change", syncVariantFromHero);
      syncVariantFromHero();
    }

    const heroTarget =
      document.querySelector(".codex-hero product-form") ||
      document.querySelector(".codex-hero-v2 product-form") ||
      document.querySelector("[data-codex-submit]");

    const footerEl = document.querySelector(SELECTORS.footer);

    let heroVisible = true;
    let footerVisible = false;
    const desktopQuery = window.matchMedia("(min-width: 750px)");

    const isEnabledForViewport = () => {
      const mobileEnabled = root.dataset.showMobile === "true";
      const desktopEnabled = root.dataset.showDesktop === "true";
      return desktopQuery.matches ? desktopEnabled : mobileEnabled;
    };

    const updateVisibility = () => {
      if (isEnabledForViewport() && !heroVisible && !footerVisible) {
        root.classList.add("is-visible");
      } else {
        root.classList.remove("is-visible");
      }
    };

    if (typeof desktopQuery.addEventListener === "function") {
      desktopQuery.addEventListener("change", updateVisibility);
    } else if (typeof desktopQuery.addListener === "function") {
      desktopQuery.addListener(updateVisibility);
    }

    if (!heroTarget) {
      if (isEnabledForViewport()) {
        root.classList.add("is-visible");
      }
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.target === heroTarget) {
            heroVisible = entry.isIntersecting;
          }
          if (footerEl && entry.target === footerEl) {
            footerVisible = entry.isIntersecting;
          }
        });
        updateVisibility();
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.01,
      }
    );

    observer.observe(heroTarget);
    if (footerEl) observer.observe(footerEl);
  };

  document.querySelectorAll(SELECTORS.root).forEach(initSection);

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector(SELECTORS.root);
    if (root) initSection(root);
  });
})();
